/* eslint-disable */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { actions as addPatient } from '../../../redux/profiles/addPatientByProvider';
import { DEPENDENT_FORM, PATIENT_REGISTRATION } from '../../../constants/routes';
import { selectIsLoggedTeam } from '../../../redux/context/selectors';
import { DIALOG_TITLE } from '../../../constants/strings';
import { IDS } from '../../../constants/ids';
import styles from '../index.styl';
import { DEPENDENT_FORM_SUBMIT_REDIRECT } from '../../../constants';
import { dependentFormActions } from '../../../redux/dependentForm/progress.actions';

const mapDispatchToProps = {
  clearRequest: addPatient.clear,
  setDependentSubmitRedirect: dependentFormActions.setSubmitRedirect,
};

const mapStateToProps = state => ({
  isLoggedTeam: selectIsLoggedTeam(state),
});

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class AssignMenuList extends Component {
  static propTypes = {
    isProvider: PropTypes.bool,
    renderItems: PropTypes.func,
    selectItem: PropTypes.func,
  };

  static defaultProps = {
    renderItems: () => {},
    selectItem: () => {},
  };

  handleOpenAddPatient = () => {
    browserHistory.push(`/${PATIENT_REGISTRATION}`);
    this.props.selectItem();
    this.props.clearRequest();
  };


  handleDependentRedirect() {
    this.props.setDependentSubmitRedirect(DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE);
    browserHistory.push(DEPENDENT_FORM);
    this.props.selectItem();
  }

  getMenuItems() {
    const { isProvider, intl: { formatMessage }, isLoggedTeam } = this.props;

    let menuItems = [];

    const createDependentItem = {
      text: formatMessage(DIALOG_TITLE.addDependent),
      id: IDS.NAV_BAR.ADD_DEPENDENT_MENU_ITEM,
      onClick: () => this.handleDependentRedirect(),
    };

    const providerItems = [
      {
        text: formatMessage(DIALOG_TITLE.addPatient),
        id: IDS.NAV_BAR.ADD_PATIENT_MENU_ITEM,
        onClick: () => this.handleOpenAddPatient(),
      },
    ];

    if (isProvider) {
      menuItems = providerItems;
    }

    if (!isLoggedTeam) {
      menuItems.push(createDependentItem);
    }

    return menuItems;
  }


  render() {
    const {
      renderItems,
    } = this.props;

    const items = this.getMenuItems();

    return (
      <Fragment>
        {renderItems(items)}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/AssignMenuList.jsx